import { useLazyQuery, useMutation } from "@apollo/react-hooks";
import { PhantomWalletAdapter } from "@solana/wallet-adapter-phantom";
import { useWallet } from "@solana/wallet-adapter-react";
import bs58 from "bs58";
import { LOGIN_USER_WALLET } from "@graphql/Mutations";
import { GET_SINGLE_USER } from "@graphql/Queries";
import jwt_decode from "jwt-decode";
import { useState } from "react";
import useReduxState from "./useReduxState";

export default function useUserLogin(): [
  () => Promise<void>,
  string | null,
  string
] {
  const phantomWallet = new PhantomWalletAdapter();
  const { publicKey, signMessage } = useWallet();
  const [, setUser] = useReduxState((state) => state.userData);
  const [errorMsg, setErrorMsg] = useState("");
  const [token, setToken] = useState<string | null>(null);

  const [loginUser] = useMutation(LOGIN_USER_WALLET, {
    onCompleted: async (data) => {
      const token = (data as any).loginUserWallet.token;
      localStorage.setItem("token", token);
      const decodedToken = jwt_decode(token);
      setToken(token);
      await fetchUser({
        variables: {
          userId: (decodedToken as any).uid,
        },
      });
    },
    onError: (error) => {
      setErrorMsg(error.message);
    },
  });
  const [fetchUser] = useLazyQuery(GET_SINGLE_USER, {
    onCompleted: (data) => {
      setUser({
        type: "SET_USER_DATA",
        arg: data.getSingleUser,
      });
    },
    onError: (error) => {
      setErrorMsg(error.message);
    },
  });

  async function handleLoginUser() {
    const message = new TextEncoder().encode(`
      Welcome to Duelana!

      Click to sign in and accept the Duelana Terms of Service: https://duelana.test/tos

      This request will not trigger a blockchain transaction or cost any gas fees.

      Your authentication status will reset after 24 hours.

      Wallet address:
      ${publicKey?.toString()}
    `);
    const encodedMessage = bs58.encode(message);

    if (signMessage) {
      const signature = phantomWallet && (await signMessage(message));
      const encodedSignature = bs58.encode(signature);
      await loginUser({
        variables: {
          wallet_address: publicKey?.toString(),
          message: encodedMessage,
          signature: encodedSignature,
        },
      });
    }
  }

  return [handleLoginUser, token, errorMsg];
}
